import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
export var getRedirectUrl = function getRedirectUrl(doChangePassword, search) {
  if (doChangePassword) {
    return "/loginchangepassword";
  } else if (search.substr(0, 6) === "?next=") {
    var nextLocation = search.substr(6);
    var decodedNextLocation = decodeURIComponent(nextLocation);

    // Ensure it's a relative path starting with / otherwise default to dashboard home
    if (_startsWithInstanceProperty(decodedNextLocation).call(decodedNextLocation, "/") && !_startsWithInstanceProperty(decodedNextLocation).call(decodedNextLocation, "//")) {
      return decodedNextLocation;
    }
  }
  return "/";
};